module.exports = __webpack_public_path__ + "img/Delete.e78c137c.svg";